import axios from 'axios';
const getQuestionnaireWithToken = ({ token }) =>
  axios.post('/document_drop_off/get_questionnaire_with_token', {
    token,
  });
const getTemporaryUploadLink = ({ token } = {}) =>
  axios.get(`/document_drop_off/get_temporary_upload_link?token=${token}`);
const answerQuestion = ({ id, answer, answerBy, token }) =>
  axios.post(`/document_drop_off/answer_question`, {
    id,
    answer,
    token,
    answer_by: answerBy,
  });
const encodeQuestionnaireData = ({ companyId, questionnaireId, email }) =>
  axios.post(`/document_drop_off/encode_questionnaire_data`, {
    company_id: companyId,
    questionnaire_id: questionnaireId,
    email,
  });
({});
const processDocument = ({
  token,
  id,
  documentName,
  path,
  questionnaireId,
  taxYear,
  documentType,
  markedAsOthers,
  selectedOptions,
  description,
  tags,
  sectionId,
  requiresSplitting,
}) => {
  return axios.post('/document_drop_off/process_document', {
    token,
    id,
    path,
    document_type: documentType,
    tax_year: taxYear,
    document_name: documentName,
    questionnaire_id: questionnaireId,
    marked_as_others: markedAsOthers,
    selected_options: selectedOptions,
    description: description,
    tags,
    section_id: sectionId,
    requires_splitting: requiresSplitting,
  });
};
const updateMarkedAsOthers = ({ token, extractedDocumentId, markedAsOthers }) =>
  axios.post(
    `/document_drop_off/update_marked_as_others?id=${extractedDocumentId}`,
    {
      token,
      marked_as_others: markedAsOthers,
    },
  );
const submitQuestionnaire = ({ token }) => {
  return axios.post(`/document_drop_off/submit_questionnaire`, {
    token,
  });
};
const deletePath = ({ token, path }) =>
  axios.post('/document_drop_off/delete_path', {
    token,
    path,
  });

export default {
  getQuestionnaireWithToken,
  getTemporaryUploadLink,
  encodeQuestionnaireData,
  answerQuestion,
  processDocument,
  updateMarkedAsOthers,
  submitQuestionnaire,
  deletePath,
};
